var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2.4,
    fill: "#EF8B6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79199 15.0001V4.92847H10.3198C11.5419 4.92847 12.4688 5.16366 13.1006 5.63403C13.7324 6.0998 14.0483 6.78461 14.0483 7.68848C14.0483 8.18191 13.9214 8.6177 13.6678 8.99585C13.4142 9.36938 13.0614 9.64377 12.6095 9.81901C13.1259 9.94813 13.5318 10.2087 13.8269 10.6007C14.1267 10.9926 14.2765 11.4722 14.2765 12.0395C14.2765 13.0079 13.9676 13.7411 13.3496 14.2392C12.7317 14.7372 11.8509 14.9909 10.7072 15.0001H6.79199ZM8.86719 10.6145V13.333H10.6449C11.1338 13.333 11.5142 13.2177 11.7863 12.9871C12.063 12.752 12.2013 12.4291 12.2013 12.0187C12.2013 11.0964 11.724 10.6283 10.7694 10.6145H8.86719ZM8.86719 9.14803H10.4028C11.4497 9.12958 11.9731 8.71224 11.9731 7.896C11.9731 7.43945 11.8393 7.11203 11.5719 6.91374C11.309 6.71083 10.8917 6.60938 10.3198 6.60938H8.86719V9.14803Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.d5da84b30a962c3e379faf0a625cae1c.svg";
export { ForwardRef as ReactComponent };